import React from 'react'
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { Weight } from 'lucide-react'


ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
)

const DoughnutChart = () => {
    const data = {
        labels: ['Purchases', 'Sales'],
        datasets: [{
            label: "Rupees",
            data: [10242,33550],
            backgroundColor: ["#1F2937", "#F07F1B"]
        }]
    }

    const options = {
    plugins: {
        legend: {
            labels: {
            usePointStyle: true, // this turns the box into a circle/dot
            pointStyle: 'circle',
            padding: 20,
            font: {
                size: 14,
                weight: 'bold'
            },
            },
            position: 'bottom', // optional: move legend to bottom
        },
      },
    }
  return (
    <div className='h-60 flex justify-center'>
        <Doughnut 
         data={data}
         options={options}        
        />
    </div>
  )
}

export default DoughnutChart